<script>
  export let show, align='right', style;

  function handleClick() {
    show = true;
  }
</script>

<style>
  .menu-container {
    position: relative;
    display: inline-block;
  }

  .menu {
    position: absolute;
  }

  .menu-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>

<div class="menu-container" style="{style}">
  <span on:click={handleClick} style="cursor:pointer;">
    <slot name="activator">
      <!-- optional fallback -->
    </slot>
  </span>

  {#if show}
    <div
      class="menu-backdrop"
      on:click={() => {
        show = false;
      }} />
    
      <div class="menu" style="{align}: 0">
        <slot />
      </div>
    
  {/if}
</div>
